import { ApiRoutes } from '../helpers/routes'
import { TRegisterFullInfo, TRegisterInfo } from '../hooks/useFormRegister'
import { RegisterInfoDTO } from '../models/auth'
import fetchApi from './fetchApi'

const baseUrl = `${process.env.REACT_APP_API_URL}/api/users`

class UserService {
    getCurrentUser = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.users.me}`, {
            method: 'GET',
        })
    }

    getUserUsingToken = async (token: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.users.me}`, {
            method: 'GET',
            headers: { Authorization: `Bearer ${token}` },
        })
    }

    getAllUsers = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.users.getAll}`, {
            method: 'GET',
        })
    }

    getAllGraduates = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.users.getAllGraduates}`, {
            method: 'GET',
        })
    }

    getUserById = async (userId: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.users.getById.replace(':userId', userId)}`, {
            method: 'GET',
        })
    }

    updateUser = async (info: TRegisterFullInfo) => {
        const linkedinToken = localStorage.getItem('linkedinToken')
        return fetchApi(`${baseUrl}${ApiRoutes.users.update}`, {
            method: 'PUT',
            body: JSON.stringify(new RegisterInfoDTO(info)),
            headers: linkedinToken
                ? {
                      Authorization: `Bearer ${linkedinToken}`,
                  }
                : {},
        })
    }

    validateDocumentIdentifier = async (info: TRegisterInfo) => {
        const params = new URLSearchParams({
            documentType: info.documentType,
            documentValue: info.documentValue,
        })
        return fetchApi(
            `${baseUrl}${ApiRoutes.users.validateDocumentIdentifier}?${params.toString()}`,
            {
                method: 'POST',
            },
        )
    }

    validatePendingUser = async (info: TRegisterInfo) => {
        const params = new URLSearchParams({
            documentType: info.documentType,
            documentValue: info.documentValue,
        })
        return fetchApi(`${baseUrl}${ApiRoutes.users.validatePendingUser}?${params.toString()}`, {
            method: 'POST',
        })
    }

    getPendingUsers = async () => {
        return fetchApi(`${baseUrl}${ApiRoutes.users.getPendingUsers}`, {
            method: 'GET',
        })
    }

    approveUser = async (userId: string) => {
        return fetchApi(`${baseUrl}${ApiRoutes.users.approve.replace(':userId', userId)}`, {
            method: 'PATCH',
        })
    }

    rejectUser = async (userId: string, object: { rejectionReason: string }) => {
        return fetchApi(`${baseUrl}${ApiRoutes.users.reject.replace(':userId', userId)}`, {
            method: 'PATCH',
            body: JSON.stringify(object),
        })
    }

    getCredential = async (userId: string, university: string) => {
        return fetchApi(
            `${baseUrl}${ApiRoutes.users.credential.replace(':userId', userId).replace(':university', university)}`,
            {
                method: 'GET',
            },
        )
    }
}

export default UserService
